<form class="responsive-grid" [class.loading]="isLoading" *ngIf="model" #form="ngForm">
    <ui-banner variant="warning" class="margin-bottom-4">
        <p>{{ 'settings.indeed-form.jobPostingCardLabel' | translate }}</p>
    </ui-banner>

    <mat-form-field class="margin-bottom-4">
        <mat-label>{{ 'settings.indeed-form.yourIndeedSourceName' | translate }}</mat-label>
        <input matInput type="text" name="sourceName" required [(ngModel)]="model.sourceName" #sourceName="ngModel" />
        <mat-hint class="margin-top-1">
            {{ 'settings.indeed-form.sourceNameHint' | translate }}
        </mat-hint>
        <mat-error *ngIf="sourceName.invalid">{{ sourceName.errors | formErrors }}</mat-error>
    </mat-form-field>

    <div class="margin-bottom-4">
        <mat-checkbox [(ngModel)]="model.isQuickApplyEnabled" name="quick-apply" type="checkbox">
            {{ 'settings.indeed-form.allowIndeedApply' | translate }}
        </mat-checkbox>
        <p class="hint margin-top-1">
            {{ 'settings.indeed-form.indeedApplyHint' | translate }}
        </p>
    </div>
</form>
